<template>
    <div class="ds-employees-toolbar">
        <div class="ds-glass-segment ds-employees-segment" role="group" aria-label="Список сотрудников">
            <button
                type="button"
                class="ds-glass-segment-option"
                :class="{ 'is-active': segment === 'active' }"
                :aria-pressed="segment === 'active'"
                @click="selectSegment('active')"
            >
                Активные · {{ formatCount(activeCount) }}
            </button>
            <button
                type="button"
                class="ds-glass-segment-option"
                :class="{ 'is-active': segment === 'archive' }"
                :aria-pressed="segment === 'archive'"
                :disabled="!canViewArchive"
                @click="selectSegment('archive')"
            >
                Архив<template v-if="canViewArchive"> · {{ formatCount(archiveCount) }}</template>
            </button>
        </div>
        <SearchInput v-model="search" @clear="search = ''" />
        <EmployeeFilter v-model="positionIds" label="Должность" search-placeholder="Найти должность" :options="positionOptions" />
        <EmployeeFilter v-model="departmentIds" label="Подразделение" search-placeholder="Найти подразделение" :options="departmentOptions" />
        <button
            v-if="segment === 'active' && canCreate"
            type="button"
            class="ds-glass-btn ds-glass-btn-primary ds-employees-create"
            @click="emit('create')"
        >
            + Создать
        </button>
    </div>
</template>

<script setup lang="ts">
import SearchInput from './SearchInput.vue'
import EmployeeFilter from './EmployeeFilter.vue'
import type { EmployeesSegment, FilterOption } from './employeesList'

interface Props {
    activeCount: number | null,
    archiveCount: number | null,
    canViewArchive: boolean,
    canCreate: boolean,
    positionOptions: FilterOption[],
    departmentOptions: FilterOption[]
}

defineProps<Props>()

const segment = defineModel<EmployeesSegment>('segment', { required: true })
const search = defineModel<string>('search', { required: true })
const positionIds = defineModel<string[]>('positionIds', { required: true })
const departmentIds = defineModel<string[]>('departmentIds', { required: true })

const emit = defineEmits(['create'])

// До загрузки или при ошибке — «—», не 0.
const formatCount = (count: number | null) => count === null ? '—' : count.toLocaleString('ru-RU')

const selectSegment = (value: EmployeesSegment) => {
    if (segment.value !== value) segment.value = value
}
</script>
